import { render, staticRenderFns } from "./PersonPlayVideo.vue?vue&type=template&id=162cbecb&scoped=true&"
import script from "./PersonPlayVideo.vue?vue&type=script&lang=js&"
export * from "./PersonPlayVideo.vue?vue&type=script&lang=js&"
import style0 from "./PersonPlayVideo.vue?vue&type=style&index=0&id=162cbecb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162cbecb",
  null
  
)

export default component.exports